import React, {useMemo} from 'react';
import {RecommendationSourceObjectType} from '@udemy-v2/react-recommendations';
import {LimitedAccessRecommendationsWrapper} from './limited-access-recommendations-wrapper.react-component';
import {LimitedAccessRecommendationsCarousel} from './limited-access-recommendations-carousel.react-component';

export interface UnavailableCourseTopicProps {
    /** Topic id sourced from the ACCESS_RESTRICTED extension. */
    topicId?: string;
}

interface UnavailableCourseTopicRecommendationsWrapperProps extends UnavailableCourseTopicProps {
    children: React.ReactNode;
}

/**
 * Topic-flavored wrapper around LimitedAccessRecommendationsWrapper.
 * Returns null when topicId is missing.
 */
export const UnavailableCourseTopicRecommendationsWrapper = ({
    topicId,
    children,
}: UnavailableCourseTopicRecommendationsWrapperProps) => {
    const sourceObjects =     useMemo(
        () => (topicId ? [{id: topicId, type: RecommendationSourceObjectType.Label}] : []),
        [topicId],
    );

    return (
        <LimitedAccessRecommendationsWrapper
            sourceObjects={sourceObjects}
            contextId="disabled_course_label"
        >
            {children}
        </LimitedAccessRecommendationsWrapper>
    );
};

export const UnavailableCourseTopicCarousel = ({topicId}: UnavailableCourseTopicProps) => (
    <UnavailableCourseTopicRecommendationsWrapper topicId={topicId}>
        <LimitedAccessRecommendationsCarousel />
    </UnavailableCourseTopicRecommendationsWrapper>
);
